import React from 'react';
import { useFinishTransactionEffect } from './finish-transaction-effect';
import { Routes, useLocation, useNavigationType, matchRoutes, createRoutesFromChildren } from 'react-router-dom';
import hoistNonReactStatics from 'hoist-non-react-statics';

function getApmRoutes(apm) {
  function ApmRoutes(props) {
    var location = useLocation();
    var navigationType = useNavigationType();
    React.useLayoutEffect(function () {
      var routes = createRoutesFromChildren(props.children);
      handleRouteChange(apm, routes, location);
    }, [location.pathname, navigationType, props.children]);
    useFinishTransactionEffect(apm.getCurrentTransaction());
    return React.createElement(Routes, props);
  }

  hoistNonReactStatics(ApmRoutes, Routes);
  return ApmRoutes;
}

function handleRouteChange(apm, routes, location) {
  if (!apm.isActive()) {
    return;
  }

  var name = getRouteFromLocation(routes, location);
  apm.startTransaction(name, 'route-change', {
    managed: true,
    canReuse: true
  });
}

export function getRouteFromLocation(routes, location) {
  if (!routes || routes.length === 0) {
    return location.pathname;
  }

  var branches = matchRoutes(routes, location);
  var builtPath = '';

  if (branches) {
    for (var index = 0; index < branches.length; index++) {
      var branch = branches[index];
      var route = branch.route;

      if (route) {
        if (route.index) {
          return branch.pathname;
        }

        var path = route.path;

        if (path) {
          var hasSlash = path[0] === '/' || builtPath[builtPath.length - 1] === '/';
          path = hasSlash ? path : "/" + path;
          builtPath += path;

          if (branch.pathname === location.pathname) {
            var isWildcardRoute = builtPath.slice(-2) === '/*';

            if (getNumberOfUrlSegments(builtPath) !== getNumberOfUrlSegments(branch.pathname) && !isWildcardRoute) {
              return path;
            }

            return builtPath;
          }
        }
      }
    }
  }

  return location.pathname;
}
export function getNumberOfUrlSegments(url) {
  return url.split('/').filter(function (currentSegment) {
    return currentSegment.length > 0;
  }).length;
}
export { getApmRoutes };